import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldSlider } from '@/(routers)/boards/editor/block/definitions/fields/fieldSlider';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'math_stddev',
    colour: CATEGORIES.operator.color,
    tooltip:
        '直近N件（Nはスライダーで設定、10〜50件）の値を内部に蓄積し、その標準偏差を返します。' +
        'N件に満たない間は蓄積済みの件数だけで計算し、N件を超えると古い値から順に破棄されます。',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('STDEV', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [
                { type: 'label', text: 'を直近' },
                {
                    type: 'field',
                    name: 'N',
                    instance: () => new FieldSlider(30, { min: 10, max: 50, step: 1, suffix: '件' }),
                },
                { type: 'label', text: 'で標準偏差にした数値 ' },
            ],
        },
    ],
});
